<template>
    <div>
        <ckeditor :editor="editor" v-model="fileEmail.content" :config="editorConfig" type="inline"/>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    export default {
        name: "file-email",
        components: {},
        props: {
        },

        data: () => ({
            fileId: null,
            task: null,
            editor: ClassicEditor,
            editorConfig: {
//                toolbar: ['save','document' , 'bold', 'italic', '|', 'link' ]
/*
                toolbarGroups: [
                    { name: 'document', groups: [ 'document', 'mode', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    '/',
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    '/',
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ]
*/
                // The configuration of the editor.
            },
            fileEmail:{},
        }),

        watch: {
        },

        created() {
        },

        methods: {
            getEmail(fileId, task) {
                this.fileId = fileId;
                this.task = task;
                axios.post(process.env.VUE_APP_API_URL + "/files/email/get?fileId=" + this.fileId + "&task=" + encodeURI(this.task)).then(
                    data => {
                        this.fileEmail = data;
                    }
                )
            },

            onSave() {
                axios.post(process.env.VUE_APP_API_URL + "/files/email/save?fileId=" + this.fileId + "&task=" + encodeURI(this.task), this.fileEmail).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                        } else {
                            message.error(data.description);
                        }
                    }
                )
            },

        }
    };
</script>